






































import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig } from "@/components/root/modal";
import { computed, onMounted, Ref, ref } from "@vue/composition-api";
import { UseLoading } from "@/common/composition/loading";
import { load_email_template, update_email_template } from "./api";
import { PolicyEmailTemplate } from "./model";
import { UseHtmlTemplateHandler } from "@/common/composition/use-html-template-handler";
import Processing from "@/components/table/Processing.vue";
export default Vue.extend({
  components: {
    Modal,
    Processing,
  },
  props: ["modalData"],
  setup(props, { emit }) {
    const config: ModalConfig = {
      title: "",
      desc: "",
      blank: true,
      width: "65rem",
      height: "40rem",
    };
    const email_template: Ref<PolicyEmailTemplate> = ref({
      featureId: "",
      infoTypeId: "",
      placeholdersMap: {},
      commonTemplateId: "",
      id: "",
      isCustomized: false,
      name: "",
      template: "",
    });

    const {
      editable_template,
      get_final_template,
      init: parser_init,
    } = UseHtmlTemplateHandler(".email-content-container");

    const modal_data = computed(
      () =>
        props.modalData as {
          feature_id: string;
          info_type: string;
          title: string;
        }
    );

    const [is_loading, set_loading] = UseLoading(true).as_arr();
    const [is_updating, set_is_updating] = UseLoading(false).as_arr();

    const update_template = async () => {
      set_is_updating(true);
      const { feature_id, info_type } = modal_data.value;
      const {
        commonTemplateId,
        id,
        name,
        placeholdersMap,
      } = email_template.value;
      const final_template = get_final_template();
      await update_email_template({
        common_id: commonTemplateId,
        id,
        name,
        placeholdersMap,
        feature_id,
        info_type,
        template: final_template,
      });
      set_is_updating(false);
      emit("submit");
    };

    onMounted(async () => {
      const res = await load_email_template({
        feature_id: modal_data.value.feature_id,
        info_type: modal_data.value.info_type,
      });
      set_loading(false);
      if (res.success) {
        email_template.value = res.value;
        const { placeholdersMap, template } = email_template.value;
        parser_init(template, placeholdersMap);
      }
    });

    return {
      is_loading,
      config,
      editable_template,
      email_template,
      is_updating,
      has_changes: false,
      update_template,
    };
  },
});
